import produce from 'immer';
import React from 'react';

import type { FixedPrizeDrawLostMPNotification } from '@swf/core/types/Notification';

import type { CardDataProps as GameTicketCardDataProps } from '../../components/GameTicket/GameTicket';
import GameTicketFront from '../../components/GameTicket/GameTicket';
import type { CardAction, CardViewProps, ViewConfig } from '../../config/NotificationTypes';
import { ActionType } from '../../enums';

/**
 * Fixed prize draw, lost view
 * This exists to show / hide the prizes button if winners is empty
 *
 * Wraps standard GameTicket View
 */

interface FixedPrizeDrawLostViewConfig extends ViewConfig {
  actions: CardAction[];
}
interface CardDataProps {
  cardData: FixedPrizeDrawLostMPNotification;
  viewConfig: ViewConfig & FixedPrizeDrawLostViewConfig;
}

const FixedPrizeDrawLost: React.FC<CardViewProps & CardDataProps> = (props) => {
  let { viewConfig } = props;
  if (props.cardData.attributes.winners.length === 0) {
    viewConfig = produce(viewConfig, (draft) => {
      draft.actions = draft.actions.filter(({ actionType }) => actionType !== ActionType.Secondary);
    });
  }
  const gameTicketProps = props as CardViewProps & GameTicketCardDataProps;
  return <GameTicketFront {...gameTicketProps} viewConfig={viewConfig} />;
};

export default FixedPrizeDrawLost;
